import axios from "axios";
import settings from "@/service/Settings";
import LZString from "lz-string";

const http = axios.create({
  baseURL: settings.EDIT_API_URL,
});

//todo: global error handling for expired token.
// http.interceptors.response.use(response => response, (error) => {
//   if(error.response.status === 401) {
//     // session expired, show nice toast message
//   }
// });

function setHeader(name, value, compressed = false) {
  if (compressed) {
    value = LZString.compressToEncodedURIComponent(JSON.stringify(value));
  }

  if (name === "Authorization") {
    // The Authorization is no longer prefixed with X-
    http.defaults.headers.common["Authorization"] = value;
  } else {
    http.defaults.headers.common["X-" + name] = value;
  }
}

function removeHeader(name) {
  delete http.defaults.headers.common[name];
}

export { http, setHeader, removeHeader };
